module.exports = __webpack_public_path__ + "img/WaLogin-Input-BG.f2822fae.svg";